// frontend/admin-portal/src/routes/domains/treasuryRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import { PermissionRoute } from "@fiberhome/shared-ui";

import Treasury from "../../pages/Treasury";
import TreasuryAccounts from "../../pages/TreasuryAccounts";
import TreasuryBabylon from "../../pages/TreasuryBabylon";

export default function TreasuryRoutes() {
  return (
    <Route element={<PermissionRoute permission="treasury.read" />}>
      <Route path="treasury" element={<Treasury />} />
      <Route path="treasury/accounts" element={<TreasuryAccounts />} />

      {/* Babylon has its own extra permission */}
      <Route element={<PermissionRoute permission="treasury.babylon" />}>
        <Route path="treasury/babylon" element={<TreasuryBabylon />} />
      </Route>
    </Route>
  );
}
